// extracted by mini-css-extract-plugin
export default {"root":"ContactDetailAnalysisConclusionList_root__SObdd","subheadingItem":"ContactDetailAnalysisConclusionList_subheadingItem__2Ey9j"};